import { startOfDay } from 'date-fns'
import { Action } from 'redux'
import { IEvent } from '../../../models/Event'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const toggleCreateReservationModal = (
  toggle,
  roomId = null,
  from = startOfDay(new Date()),
): IToggleCreateReservation => ({
  from,
  roomId,
  toggle,
  type: ReservationModalActions.ToggleCreateReservationModal,
})

const toggleWithLoadUpdateReservationModal = (
  id: IEvent['id'],
  toggle = true,
) => ({
  id,
  toggle,
  type: ReservationModalActions.ToggleUpdateReservationModalWithLoad,
})

const toggleUpdateReservationModal = (
  id: IEvent['id'],
  toggle = true,
): IToggleUpdateReservation => ({
  id,
  toggle,
  type: ReservationModalActions.ToggleUpdateReservationModal,
})

const toggleReservationModalLoading = (
  toggle: boolean,
): IToggleReservationModalLoading => ({
  toggle,
  type: ReservationModalActions.ToggleLoading,
})

const requestCreateReservation = (
  roomId = null,
  from = new Date(),
  eventId = null,
): IRequestCreateReservation => ({
  eventId,
  from,
  roomId,
  type: ReservationModalActions.RequestCreateReservation,
})

const toggleReservationModalIsSaving = (
  toggle: boolean,
): IToggleReservationModalSaving => ({
  toggle,
  type: ReservationModalActions.ToggleSaving,
})

export {
  toggleCreateReservationModal,
  toggleUpdateReservationModal,
  toggleReservationModalLoading,
  requestCreateReservation,
  toggleWithLoadUpdateReservationModal,
  toggleReservationModalIsSaving,
}

export interface IRequestCreateReservation
  extends Action<ReservationModalActions.RequestCreateReservation> {
  roomId?: string
  from?: Date
  eventId?: IEvent['id']
}

export interface IToggleCreateReservation
  extends Action<ReservationModalActions.ToggleCreateReservationModal> {
  roomId?: string
  from?: Date
  toggle: boolean
}

export interface IToggleUpdateReservation
  extends Action<ReservationModalActions.ToggleUpdateReservationModal> {
  id: IEvent['id']
  toggle: boolean
}

export interface IToggleReservationModalLoading
  extends Action<ReservationModalActions.ToggleLoading> {
  toggle: boolean
}

export interface IToggleReservationModalSaving
  extends Action<ReservationModalActions.ToggleSaving> {
  toggle: boolean
}
